'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var InfoCircle = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "currentColor", viewBox: "0 0 40 41" }, props),
    React__default['default'].createElement("path", { d: "M20 11c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 1c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm-.006 6.206c.154 0 .308.154.308.308v5.852c0 .168-.154.308-.308.308h-.42c-.168 0-.308-.14-.308-.308v-5.852c0-.154.14-.308.308-.308h.42zM19.756 15c.434 0 .77.336.77.784 0 .406-.336.756-.77.756-.42 0-.756-.35-.756-.756 0-.448.336-.784.756-.784z" }))); };

exports.default = InfoCircle;
//# sourceMappingURL=index.js.map
